import { Component, OnInit, ViewChild,Input } from '@angular/core';
import { IonContent, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { CustomerModel } from 'src/app/models/customer-model';
import { WireModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-deposit-wire',
  templateUrl: './deposit-wire.component.html',
  styleUrls: ['./deposit-wire.component.scss'],
})
export class DepositWireComponent implements OnInit {


  @ViewChild(IonContent, { static: false }) content: IonContent;

  public labels: DepositMainLabels;
  public userSession: UserSessionService;
  public customer: CustomerModel;

  public accountNumber: string;
  public accountName: string;
  public address: string;
  public bankName: string;
  public swift: string;
  public limits: string;
  public limit24hrLabel: string;
  public limit30dayLabel: string;
  public limit24hrValue: string;
  public limit30dayValue: string;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform,
    public UserSessionService: UserSessionService,
    public successMessageService: SuccessMessageService,
  ){
    this.labels = new WireModel();

    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  ngOnInit() {
    const config = this.config.getConfig();
    this.accountNumber = config.FEATURE_WIRE_ACCOUNT_NUM ?? '4128656048 ';
    this.address = config.FEATURE_WIRE_ADDRESS ?? '';
    this.bankName = config.FEATURE_WIRE_BANK_NAME ?? 'Wells Fargo';
    this.limits = config.FEATURE_WIRE_LIMITS ?? '';
    this.swift = config.FEATURE_WIRE_SWIFT ?? '121000248 ';
    this.accountName = config.FEATURE_WIRE_ACCOUNT_NAME ?? 'Pala Interactive, LLC';

    let obj = JSON.parse(this.limits);
    let limits24hr = obj[0];
    let limits30day = obj[1];
    
    this.limit24hrLabel = limits24hr.label;
    this.limit24hrValue = limits24hr.value;
    
    this.limit30dayLabel = limits30day.label;
    this.limit30dayValue = limits30day.value;
  }
  
  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('wire').then((response: WireModel) => {
      this.labels = response;
    });
  }
}
